module.exports = __webpack_public_path__ + "img/source_book-item14.304d641c.png";